var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7266 15.0287C44.1649 15.0287 51.004 23.218 51.004 32.3058C51.004 35.2083 50.208 38.1972 48.811 40.927C48.551 41.3762 48.5186 41.9464 48.6973 42.4819L49.7857 46.352C50.0293 47.285 49.2821 47.9761 48.4536 47.6996L45.1721 46.663C44.2786 46.352 43.5801 46.7494 42.75 47.285C40.3782 48.7708 37.4233 49.531 34.7591 49.531C26.7017 49.531 18.5142 42.9139 18.5142 32.2539C18.5142 23.0625 25.4995 15.0287 34.7266 15.0287",
    fill: "url(#paint0_linear_452_1236)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_452_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0998 32.4779C45.0998 38.6417 40.4028 43.636 34.6083 43.636C28.8139 43.636 24.1168 38.6417 24.1168 32.4779C24.1168 26.3164 28.8139 21.3198 34.6083 21.3198C40.4028 21.3198 45.0998 26.3164 45.0998 32.4779Z",
    fill: "#8237FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_452_1236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_452_1236",
    maskUnits: "userSpaceOnUse",
    x: 0.761719,
    y: 0.531006,
    width: 44,
    height: 47,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.761719,
    y: 0.531006,
    width: 44,
    height: 47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5323 1.53101C10.4887 1.53101 1.76172 11.9809 1.76172 23.5772C1.76172 27.281 2.77745 31.095 4.56015 34.5783C4.89182 35.1515 4.93328 35.879 4.70526 36.5625L3.3164 41.5008C3.00547 42.6913 3.95901 43.5732 5.01619 43.2204L9.20348 41.8977C10.3436 41.5008 11.2349 42.0079 12.2942 42.6913C15.3206 44.5873 19.0913 45.5573 22.4909 45.5573C32.7725 45.5573 43.22 37.1136 43.22 23.5111C43.22 11.7825 34.3065 1.53101 22.5323 1.53101"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5323 1.53101C10.4887 1.53101 1.76172 11.9809 1.76172 23.5772C1.76172 27.281 2.77745 31.095 4.56015 34.5783C4.89182 35.1515 4.93328 35.879 4.70526 36.5625L3.3164 41.5008C3.00547 42.6913 3.95901 43.5732 5.01619 43.2204L9.20348 41.8977C10.3436 41.5008 11.2349 42.0079 12.2942 42.6913C15.3206 44.5873 19.0913 45.5573 22.4909 45.5573C32.7725 45.5573 43.22 37.1136 43.22 23.5111C43.22 11.7825 34.3065 1.53101 22.5323 1.53101",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5323 2.53101C23.0846 2.53101 23.5323 2.08329 23.5323 1.53101C23.5323 0.978721 23.0846 0.531006 22.5323 0.531006V2.53101ZM4.56015 34.5783L3.66996 35.0339C3.67779 35.0492 3.686 35.0643 3.6946 35.0791L4.56015 34.5783ZM4.70526 36.5625L3.75666 36.246C3.75161 36.2611 3.74692 36.2764 3.7426 36.2917L4.70526 36.5625ZM3.3164 41.5008L2.35375 41.2301C2.35206 41.2361 2.35043 41.2421 2.34886 41.2481L3.3164 41.5008ZM5.01619 43.2204L4.71496 42.2669C4.70986 42.2685 4.70477 42.2702 4.69969 42.2718L5.01619 43.2204ZM9.20348 41.8977L9.50471 42.8512C9.51392 42.8483 9.52308 42.8453 9.5322 42.8421L9.20348 41.8977ZM12.2942 42.6913L11.752 43.5317L11.7633 43.5388L12.2942 42.6913ZM22.5323 0.531006C21.98 0.531006 21.5323 0.978721 21.5323 1.53101C21.5323 2.08329 21.98 2.53101 22.5323 2.53101V0.531006ZM22.5323 0.531006C9.8475 0.531006 0.761719 11.5219 0.761719 23.5772H2.76172C2.76172 12.4399 11.1299 2.53101 22.5323 2.53101V0.531006ZM0.761719 23.5772C0.761719 27.46 1.82505 31.4291 3.66996 35.0339L5.45034 34.1227C3.72984 30.761 2.76172 27.1021 2.76172 23.5772H0.761719ZM3.6946 35.0791C3.8598 35.3646 3.90963 35.7875 3.75666 36.246L5.65385 36.879C5.95692 35.9706 5.92383 34.9384 5.4257 34.0775L3.6946 35.0791ZM3.7426 36.2917L2.35375 41.2301L4.27906 41.7716L5.66791 36.8332L3.7426 36.2917ZM2.34886 41.2481C2.11108 42.1585 2.34289 43.0551 2.95316 43.6534C3.56246 44.2508 4.46106 44.4599 5.3327 44.169L4.69969 42.2718C4.51414 42.3338 4.40738 42.2783 4.35335 42.2253C4.30028 42.1733 4.21079 42.0336 4.28395 41.7535L2.34886 41.2481ZM5.31742 44.174L9.50471 42.8512L8.90225 40.9441L4.71496 42.2669L5.31742 44.174ZM9.5322 42.8421C10.163 42.6225 10.6587 42.8262 11.752 43.5316L12.8363 41.851C11.8112 41.1896 10.5242 40.3791 8.87475 40.9532L9.5322 42.8421ZM11.7633 43.5388C14.9625 45.5429 18.9202 46.5573 22.4909 46.5573V44.5573C19.2624 44.5573 15.6788 43.6317 12.8251 41.8439L11.7633 43.5388ZM22.4909 46.5573C33.3037 46.5573 44.22 37.6868 44.22 23.5111H42.22C42.22 36.5405 32.2413 44.5573 22.4909 44.5573V46.5573ZM44.22 23.5111C44.22 11.3121 34.9372 0.531006 22.5323 0.531006V2.53101C33.6757 2.53101 42.22 12.2529 42.22 23.5111H44.22Z",
    fill: "url(#paint1_linear_452_1236)",
    mask: "url(#path-3-outside-1_452_1236)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_452_1236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_452_1236",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4503 26.421C20.9786 26.3989 19.797 25.1423 19.797 23.577C19.797 22.0338 20.9993 20.7551 22.4503 20.7771C23.9221 20.7771 25.1037 22.0338 25.1037 23.5991C25.1037 25.1423 23.9221 26.421 22.4503 26.421ZM12.8934 26.421C11.4424 26.421 10.2401 25.1423 10.2401 23.5991C10.2401 22.0338 11.4217 20.7772 12.8934 20.7772C14.3652 20.7772 15.5468 22.0338 15.5468 23.5991C15.5468 25.1423 14.3652 26.399 12.8934 26.421ZM29.3528 23.5991C29.3528 25.1423 30.5344 26.421 32.0061 26.421C33.4779 26.421 34.6595 25.1423 34.6595 23.5991C34.6595 22.0338 33.4779 20.7771 32.0061 20.7771C30.5344 20.7771 29.3528 22.0338 29.3528 23.5991Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4503 26.421C20.9786 26.3989 19.797 25.1423 19.797 23.577C19.797 22.0338 20.9993 20.7551 22.4503 20.7771C23.9221 20.7771 25.1037 22.0338 25.1037 23.5991C25.1037 25.1423 23.9221 26.421 22.4503 26.421ZM12.8934 26.421C11.4424 26.421 10.2401 25.1423 10.2401 23.5991C10.2401 22.0338 11.4217 20.7772 12.8934 20.7772C14.3652 20.7772 15.5468 22.0338 15.5468 23.5991C15.5468 25.1423 14.3652 26.399 12.8934 26.421ZM29.3528 23.5991C29.3528 25.1423 30.5344 26.421 32.0061 26.421C33.4779 26.421 34.6595 25.1423 34.6595 23.5991C34.6595 22.0338 33.4779 20.7771 32.0061 20.7771C30.5344 20.7771 29.3528 22.0338 29.3528 23.5991Z",
    fill: "url(#paint2_linear_452_1236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4503 26.421L22.4443 26.821H22.4503V26.421ZM22.4503 20.7771L22.4442 21.1771H22.4503V20.7771ZM12.8934 26.421L12.8934 26.8211L12.8994 26.821L12.8934 26.421ZM19.397 23.577C19.397 25.3412 20.7348 26.7953 22.4443 26.8209L22.4563 26.021C21.2223 26.0025 20.197 24.9434 20.197 23.577H19.397ZM22.4564 20.3772C20.7555 20.3513 19.397 21.8381 19.397 23.577H20.197C20.197 22.2295 21.2431 21.1588 22.4442 21.1771L22.4564 20.3772ZM25.5037 23.5991C25.5037 21.8364 24.1659 20.3771 22.4503 20.3771V21.1771C23.6783 21.1771 24.7037 22.2311 24.7037 23.5991H25.5037ZM22.4503 26.821C24.1678 26.821 25.5037 25.3375 25.5037 23.5991H24.7037C24.7037 24.947 23.6764 26.021 22.4503 26.021V26.821ZM9.84011 23.5991C9.84011 25.3397 11.1986 26.821 12.8934 26.821V26.021C11.6862 26.021 10.6401 24.945 10.6401 23.5991H9.84011ZM12.8934 20.3772C11.1779 20.3772 9.84011 21.8365 9.84011 23.5991H10.6401C10.6401 22.2312 11.6654 21.1772 12.8934 21.1772V20.3772ZM15.9468 23.5991C15.9468 21.8365 14.609 20.3772 12.8934 20.3772V21.1772C14.1214 21.1772 15.1468 22.2312 15.1468 23.5991H15.9468ZM12.8994 26.821C14.607 26.7954 15.9468 25.3433 15.9468 23.5991H15.1468C15.1468 24.9414 14.1234 26.0025 12.8875 26.0211L12.8994 26.821ZM32.0061 26.021C30.7801 26.021 29.7528 24.947 29.7528 23.5991H28.9528C28.9528 25.3375 30.2886 26.821 32.0061 26.821V26.021ZM34.2595 23.5991C34.2595 24.947 33.2322 26.021 32.0061 26.021V26.821C33.7236 26.821 35.0595 25.3375 35.0595 23.5991H34.2595ZM32.0061 21.1771C33.2341 21.1771 34.2595 22.2311 34.2595 23.5991H35.0595C35.0595 21.8364 33.7217 20.3771 32.0061 20.3771V21.1771ZM29.7528 23.5991C29.7528 22.2311 30.7781 21.1771 32.0061 21.1771V20.3771C30.2906 20.3771 28.9528 21.8364 28.9528 23.5991H29.7528Z",
    fill: "url(#paint3_linear_452_1236)",
    mask: "url(#path-5-inside-2_452_1236)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_452_1236",
    x: 7.11682,
    y: 4.31982,
    width: 54.9829,
    height: 56.3162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_452_1236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_452_1236",
    x: -23.2383,
    y: -23.469,
    width: 91.4583,
    height: 94.0264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_452_1236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_452_1236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_452_1236",
    x: -4.75989,
    y: 5.77686,
    width: 54.4193,
    height: 35.6442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_452_1236"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_452_1236",
    result: "effect2_dropShadow_452_1236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_452_1236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_1236",
    x1: 34.7591,
    y1: 15.0287,
    x2: 34.7591,
    y2: 49.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_452_1236",
    x1: 8.3612,
    y1: 6.66013,
    x2: 36.7538,
    y2: 39.7739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_452_1236",
    x1: 32.9281,
    y1: 21.7961,
    x2: 6.22967,
    y2: 25.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_452_1236",
    x1: 14.1273,
    y1: 21.4344,
    x2: 15.4557,
    y2: 28.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.ff88da16b2507ff31cdaadcdb5935109.svg";
export { ForwardRef as ReactComponent };